import { Heart } from "@phosphor-icons/react";
import { favorites, useLocalList } from "@/lib/storage";

export default function FavoriteButton({ id, className = "" }) {
  const list = useLocalList(favorites);
  const active = list.includes(id);
  return (
    <button
      type="button"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); favorites.toggle(id); }}
      className={`w-10 h-10 flex items-center justify-center transition-colors shadow-sm ${
        active ? "bg-[#001588] text-white" : "bg-white text-[#001588] hover:bg-[#001588] hover:text-white"
      } ${className}`}
      aria-label={active ? "Remove from favourites" : "Save to favourites"}
      data-testid={`favorite-${id}`}
    >
      <Heart size={16} weight={active ? "fill" : "regular"} />
    </button>
  );
}
